import styled from 'styled-components';
import { RightTooltip } from 'ui/tooltip';

const Label = styled.span`
  padding: 2.5px 10px;
  margin-left: 20px;
  border: 1px solid #c3c3c5;
  border-radius: 16px;
  cursor: default;
`;

export const LegacyDomainLabel = () => (
  <RightTooltip tooltipContent={'Rewriting all paths under the top-level domain as deep links'}>
    <Label>Legacy</Label>
  </RightTooltip>
);
